import ManageBeacons from './ManageBeacons'
import NotificationBeacons from './NotificationBeacons'
import { AccessType } from 'app/auth/accessControlService'

export const subRoutes = [
  {
    path: 'beacon/manage',
    component: ManageBeacons,
  },
  {
    path: 'beacon/notification',
    component: NotificationBeacons,
  },
]

export const BeaconConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/beacon/manage',
      component: ManageBeacons,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: '/beacon/notification',
      component: NotificationBeacons,
      accesses: [AccessType.ADMINISTRATION, AccessType.NOTIFICATION_VIEW_OWNED],
    },
  ],
}
